import React from "react";

const HFLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    viewBox="0 0 1098 868"
  >
    <defs>
      <path
        id="a"
        d="M71.5564185,23.2172257 C38.0610605,28.6720604 10.9120327,15.3710143 1.67442904,32.5459253 C-7.56317464,49.7200844 21.6638617,94.562344 83.3408452,81.7206287 C145.017829,68.8796651 159.028747,13.8449236 142.730286,2.72475889 C126.431824,-8.39615757 105.051023,17.7631428 71.5564185,23.2172257 Z"
      />
      <path
        id="c"
        d="M0,0 L271,0 L222.309629,50.8158172 L204.490213,50.8158172 L189.14557,48.2155001 L177.17123,70.0955371 C207.735383,83.1739792 246.131667,98.2303502 271,119.999623 L271,240 L0,240 L0,0 Z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFD21E"
        fillRule="nonzero"
        stroke="#FF9D00"
        strokeWidth="15"
        d="M834.81385,385.340502 C840.337747,384.603553 845.90784,385.363078 850.703636,388.316801 C855.749939,391.42391 858.956433,396.29566 860.460258,402.044418 C863.034934,411.880164 859.340389,425.406653 849.747511,436.662456 C846.999838,439.886505 842.623027,443.10964 837.815896,446.505728 C832.904543,449.975444 827.407693,453.681212 823.937678,458.424197 C823.715144,458.728367 825.372545,459.47396 825.372545,459.47396 L825.372545,459.47396 L825.81339,460.801397 C826.754663,464.07564 827.372886,467.22198 827.174071,469.408912 C826.956568,471.801408 826.069018,473.673753 824.805212,475.111553 C823.493041,476.604376 821.691518,477.805774 819.018295,478.214515 C818.422528,478.305612 817.879726,478.445522 817.39742,478.62094 C817.302931,479.502169 817.109816,480.258607 816.815159,481.179505 C816.43752,482.359749 815.79156,484.15604 814.869515,486.565738 C813.144742,491.073305 810.402455,497.880922 806.641007,506.987943 C799.205552,524.99028 787.75952,552.050266 772.305304,588.168211 C771.16748,591.81721 768.462329,594.787772 764.902598,596.252141 C761.110363,597.813033 756.800329,597.476967 753.294832,595.346979 L753.294832,595.346979 L730.135827,581.271433 C712.010668,568.160772 697.212515,554.563692 687.802184,538.709048 C677.904399,522.030994 673.948283,503.172595 678.152156,480.702511 C681.489595,462.860892 688.683748,449.474707 700.60604,440.127783 C712.058916,431.148027 727.380163,426.45787 746.717904,424.897709 C761.92719,423.670332 772.045878,420.599045 780.366222,416.371739 C787.474931,412.759821 793.360735,408.345191 800.256158,403.224539 C801.982707,401.942829 803.718882,400.654049 805.541023,399.321541 C816.403647,391.386157 826.51299,386.449167 834.81385,385.340502 Z"
      />
      <line
        x1="709.545"
        x2="925.922"
        y1="561.881"
        y2="351.942"
        stroke="#3C7EFF"
        strokeLinecap="round"
        strokeWidth="32.644"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="5.154"
        d="M883.097226,363.752502 C908.865149,357.536938 920.787448,375.019614 913.095931,394.833013"
      />
      <path
        fill="#FFD21E"
        fillRule="nonzero"
        stroke="#FF9D00"
        strokeWidth="11.104"
        d="M745.514428,553.040388 C745.377433,552.960096 745.268196,552.897646 745.189401,552.852147 C739.743633,549.373692 733.077446,548.635 728.262929,552.096504 C725.779114,553.882569 724.159352,556.611626 723.867454,559.811732 C723.585406,562.896753 724.563173,565.979098 726.351269,568.785771 L726.380817,568.834839 C726.428273,568.913347 726.496322,569.024864 726.583175,569.167607 C726.758672,569.4522 727.011172,569.859908 727.335304,570.36932 C727.981776,571.386359 728.914774,572.813784 730.0752,574.485655 C732.381728,577.807985 735.651696,582.184825 739.416815,586.219975 C743.095977,590.163234 747.641877,594.213551 752.554888,596.374314 C755.069146,597.479676 757.923653,598.199633 760.937539,597.950726 C764.040964,597.695574 766.93845,596.439441 769.441068,594.200169 C771.909661,591.99123 773.507934,589.283584 773.998608,586.189642 C774.474956,583.185806 773.824902,580.339879 772.762968,577.890062 C770.706255,573.148336 766.621481,568.790231 762.705936,565.313561 C758.6722,561.73251 754.25434,558.602883 750.898415,556.393051 C749.208812,555.280552 747.762755,554.384844 746.73216,553.763022 C746.216415,553.451665 745.802744,553.208111 745.514428,553.040388 Z"
      />
      <path
        fill="#FFD21E"
        fillRule="nonzero"
        stroke="#FF9D00"
        strokeWidth="11.104"
        d="M762.762353,523.807073 L762.751666,523.800832 C756.37811,519.698525 748.802132,518.963751 743.45789,522.826535 C740.710492,524.811911 738.920306,527.839757 738.595156,531.405078 C738.280725,534.857116 739.364653,538.373898 741.445321,541.651368 L741.488055,541.723607 C741.545034,541.817249 741.626051,541.951917 741.731107,542.124041 C741.941218,542.468289 742.245702,542.961472 742.63655,543.57951 C743.417356,544.813801 744.545397,546.550184 745.949473,548.582631 C748.741597,552.627014 752.691278,557.938591 757.226252,562.824541 C761.676635,567.617747 767.081827,572.433892 772.842111,574.978968 C775.780141,576.276021 779.054086,577.0931 782.470831,576.809441 C785.977538,576.51773 789.262762,575.094158 792.128777,572.517369 C794.959157,569.970917 796.748465,566.894905 797.298044,563.416046 C797.833349,560.026388 797.11186,556.777103 795.879014,553.91864 C793.481863,548.359574 788.667295,543.164182 783.928181,538.935674 C779.071524,534.601944 773.7391,530.803526 769.672938,528.113502 C767.629171,526.760911 765.879261,525.671376 764.634281,524.917092 C764.010901,524.539058 763.513085,524.244836 763.165771,524.041557 C762.993005,523.939917 762.856751,523.861459 762.762353,523.807073 Z"
        transform="rotate(-10 768.01 548.58)"
      />
      <path
        fill="#FFD21E"
        fillRule="nonzero"
        stroke="#FF9D00"
        strokeWidth="11.104"
        d="M769.750446,491.092903 L769.690169,491.07165 C761.858586,487.904001 753.396753,487.969532 748.352097,492.723219 C745.61747,495.299314 744.36938,498.931882 745.029769,502.800009 C745.649381,506.425492 747.841515,509.787078 750.961738,512.728024 L751.045949,512.811266 C751.135478,512.899822 751.264896,513.027343 751.433317,513.190286 C751.768387,513.517058 752.255922,513.98729 752.878194,514.576188 C754.120964,515.753097 755.905342,517.405553 758.090385,519.329875 C762.443628,523.16435 768.459808,528.140313 774.99898,532.581397 C781.453055,536.964035 788.8104,541.100486 795.802536,542.887547 C802.831903,544.685234 810.865591,544.358462 816.424375,537.678682 C819.05795,534.51369 820.294515,530.880236 819.922216,527.05196 C819.568532,523.417621 817.825816,520.215435 815.715233,517.553441 C811.556118,512.304726 804.774064,507.666162 798.171069,503.922013 C791.429792,500.09905 784.275439,496.879153 778.854938,494.628945 C776.133607,493.49897 773.823578,492.603669 772.189007,491.988204 C771.371721,491.680029 770.721083,491.441814 770.271665,491.279756 C770.046512,491.198285 769.871,491.13541 769.750446,491.092903 Z"
      />
      <path
        fill="#FFD21E"
        fillRule="nonzero"
        stroke="#FF9D00"
        strokeWidth="11.104"
        d="M779.823423,468.901048 L779.764635,468.906374 C771.359583,469.313021 763.762962,472.96743 761.215501,479.439754 C759.84345,482.926497 760.230797,486.746679 762.429707,489.995934 C764.49759,493.050699 767.87629,495.212343 771.926289,496.595647 L772.034089,496.635829 C772.151688,496.678691 772.32185,496.740306 772.541011,496.81978 C772.978443,496.976943 773.612762,497.201976 774.41724,497.478813 C776.025303,498.031594 778.31667,498.792483 781.081956,499.632065 C786.592038,501.304975 794.072633,503.32301 801.802336,504.631199 C809.427812,505.920612 817.778998,506.607414 824.8297,505.290443 C831.944531,503.961905 839.02983,500.2493 841.23172,491.813752 C842.272192,487.827401 841.870593,484.006321 839.947784,480.674238 C838.116792,477.501845 835.213742,475.301162 832.19428,473.747058 C826.251582,470.688837 818.207406,469.302026 810.713151,468.658405 C803.058553,468.001337 795.286688,468.07201 789.479019,468.29783 C786.562715,468.411627 784.114968,468.565761 782.389617,468.691667 C781.526496,468.754619 780.842416,468.811406 780.37033,468.852229 C780.134287,468.872641 779.950797,468.888616 779.823423,468.901048 Z"
        transform="rotate(17 801.104 487.07)"
      />
      <path
        fill="#FFD21E"
        stroke="#FFD21E"
        strokeLinejoin="round"
        strokeWidth="6"
        d="M875.208468,310.851134 L880.949425,321.837096 L893.144764,323.908804 L884.494787,332.763733 L886.296985,345.026455 L875.208468,339.519997 L864.119951,345.026455 L865.922149,332.763733 L857.272172,323.908804 L869.46751,321.837096 L875.208468,310.851134 Z"
      />
      <path
        fill="#FFD21E"
        stroke="#FFD21E"
        strokeLinejoin="round"
        strokeWidth="6"
        d="M986.423764,293.602789 L994.271349,309.398916 L1010.62063,312.30988 L999.029532,324.780371 L1001.4639,342.253295 L986.406842,334.400081 L971.334826,342.272431 L973.788388,324.788661 L962.213097,312.333302 L978.560204,309.406376 L986.423764,293.602789 Z"
        transform="rotate(-21 986.414 318.627)"
      />
      <path
        fill="#FFD21E"
        stroke="#FFD21E"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M970.816198,378.718336 L975.796065,388.716515 L986.1347,390.568572 L978.81619,398.43848 L980.371337,409.496069 L970.83121,404.514937 L961.304869,409.478692 L962.8427,398.431254 L955.509845,390.547594 L965.850685,388.709836 L970.816198,378.718336 Z"
        transform="rotate(36 970.825 394.566)"
      />
      <circle
        cx="413.5"
        cy="435.5"
        r="301.5"
        stroke="#000"
        strokeWidth="17.067"
      />
      <circle
        cx="412.919"
        cy="434.401"
        r="301.287"
        fill="#FFD21E"
        fillRule="nonzero"
        transform="rotate(-75 412.919 434.401)"
      />
      <path
        fill="#FF9D00"
        fillRule="nonzero"
        d="M404.995128,671.251556 C589.381904,687.514254 698,516.584025 698,516.584025 C655.325167,675.894817 491.619601,770.437687 332.352921,727.750081 C173.086994,685.063226 78.5715009,521.310792 121.247086,362 C131.453065,473.551108 220.607599,654.988859 404.995128,671.251556 Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M561.780818 281.007848C570.602537 286.770621 569.598756 307.544646 580.61709 304.741236 601.485681 299.432827 614.097461 278.221683 608.785974 257.365184 603.473738 236.508684 582.251047 223.904961 561.382457 229.21337 540.513866 234.52178 527.902086 255.732923 533.214323 276.589423 535.720774 286.433223 553.894611 275.856142 561.780818 281.007848ZM366.045074 327.272948C373.142552 318.037632 396.058044 320.823172 393.850897 308.479376 389.672354 285.100815 367.217031 269.51636 343.696292 273.670262 320.174798 277.823413 304.495061 300.142282 308.67436 323.520843 312.852903 346.898652 335.308226 362.483108 358.828965 358.329957 369.931195 356.369038 359.700187 335.528181 366.045074 327.272948Z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        stroke="#000"
        strokeWidth="19.548"
        d="M472.556418,344.217575 C439.061061,349.672378 411.911279,336.370656 402.674429,353.545469 C393.436825,370.720282 422.663862,415.562285 484.340845,402.720643 C546.017829,389.879753 560.028747,334.845326 543.730286,323.724473 C527.431824,312.604372 506.051023,338.762771 472.556418,344.217575 Z"
      />
      <g transform="translate(401 321)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="red"
          fillRule="nonzero"
          d="M60.0124288,60.1493736 C48.0011321,61.8160451 41.527423,84.7901008 42.4793726,92.4619019 C42.4793726,92.4619019 41.3246721,122.174814 92.3832351,110.201391 C143.441044,98.2279689 131.943032,72.9114014 131.943032,72.9114014 C129.867284,62.6069059 114.623279,49.2073781 104.449553,51.2446716 C94.2750747,53.282717 91.422241,68.3090726 84.2347582,69.7494617 C77.0465217,71.1906025 72.0237255,58.4834538 60.0124288,60.1493736 Z"
          mask="url(#b)"
        />
      </g>
      <circle
        cx="249.541"
        cy="374.89"
        r="30.446"
        fill="#FF9D00"
        fillRule="nonzero"
        transform="rotate(22.665 249.541 374.89)"
      />
      <circle
        cx="655.531"
        cy="309.371"
        r="30.446"
        fill="#FF9D00"
        fillRule="nonzero"
        transform="rotate(22.665 655.531 309.37)"
      />
      <circle
        cx="413.5"
        cy="435.5"
        r="301.5"
        stroke="#FF9D00"
        strokeWidth="17.067"
      />
      <polygon
        fill="#FFF"
        fillRule="nonzero"
        points="572.332 550.233 620.855 530 620.855 544.418 638 544.418 635.434 567.79 570 575"
      />
      <polygon
        fill="#FFF"
        fillRule="nonzero"
        points="522.565 528.233 471.902 508 471.902 522.418 454 522.418 456.679 545.79 525 553"
      />
      <path
        fill="#097EFF"
        fillRule="nonzero"
        d="M317,713.12489 L426.320884,535.382191 C473.855533,528.580645 530.494547,547.170482 559.70379,584.762577 C559.70379,584.762577 559.27774,582.09353 557.875389,577.737102 C559.480979,582.064879 559.70379,584.762577 559.70379,584.762577 C592.744469,560.233733 613.389813,555.280163 652,553.855917 L537.391132,721.113936 C508.44083,722.060166 485.922675,735.623297 449.317781,753 C415.18789,727.500045 382.397873,713.12489 317,713.12489 Z"
      />
      <path
        stroke="#005DC5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="14.751"
        d="M559.70379,584.837339 C530.494547,547.261949 473.855533,528.680373 426.320884,535.478897 L317,713.14261 C382.397873,713.14261 415.18789,727.511377 449.317781,753 M559.70379,584.837339 C592.744469,560.319395 613.389813,555.368026 652,553.944413 L537.391132,721.128105 C508.44083,722.073915 485.922675,735.631019 449.317781,753 M559.70379,584.837339 L449.317781,753 M559.70379,584.837339 C559.70379,584.837339 574.905333,540.415193 643.524923,540.415193 L637.408175,553.944413 M559.70379,584.837339 C559.70379,584.837339 555.562226,534.738075 454.427366,520.066348 L450.085574,529.581718 M559.70379,584.837339 C559.70379,584.837339 549.870021,523.337869 469.488147,509 L468.332694,520.066348 M559.70379,584.837339 C559.70379,584.837339 561.590151,537.424777 624.816375,526.953046 L620.943538,540.415193"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M558.644659,615.757905 C558.731587,615.628059 558.841746,615.511722 558.966892,615.417903 C577.095115,601.789292 588.255613,595.714285 607.175179,589.081614 C608.390671,588.655298 609.461534,589.984534 608.795336,591.088603 L603.586404,599.717004 C603.435029,599.968441 603.20497,600.165837 602.934444,600.279171 C583.955677,608.262844 570.595752,615.997333 551.568276,629.806828 C550.690753,630.44405 549.568184,629.376008 550.169935,628.473088 L558.644659,615.757905 Z"
      />
      <g transform="translate(235 478)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <g mask="url(#d)">
          <g transform="translate(25.316 11.048)">
            <path
              fill="#FFD21E"
              fillRule="nonzero"
              d="M222.6014,125.798607 C230.279752,120.775798 231.699938,115.118545 230.446345,101.293388 L156.426306,62.7007938 C179.967172,50.0721892 184.789322,38.9091356 196.667174,20.5969054 L178.519849,1.62310514 L107.403503,32.9241114 C107.403503,32.9241114 32.3281242,14.9306103 6.62758035,65.961174 C-19.0729635,116.990984 54.2339669,189.638615 49.8452602,192.543344 L114.053652,220.535747 C143.529298,209.414135 160.122258,205.444715 189.000129,174.831651 L226.64486,171.504963 L225.017375,153.106834 L141.003266,114.625005 L222.6014,125.798607 Z"
            />
            <path
              stroke="#FF9D00"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="14.751"
              d="M135.657216 114.46451C142.718948 123.312821 191.532945 144.066381 214.845405 144.480804 230.321966 144.756584 236.604254 167.209278 215.866823 172.828857 195.129393 178.447682 149.569612 177.331753 109.004604 143.24507M183.288478 186.492766C180.514441 195.601034 137.198766 211.936089 85.6785755 177.563077"
            />
            <path
              stroke="#FF9D00"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="14.751"
              d="M147.899159,201.822656 C115.499468,232.83658 59.6342924,200.030841 46.2239365,186.430226 C32.8135805,172.82961 13.613931,132.143049 2.40320517,101.392849 C-12.2328527,61.2495592 42.292795,15.8498763 103.254509,30.4081859 C161.279363,21.9140177 170.604799,-10.543606 187.942527,3.46163708 C200.373678,13.5034875 197.923028,41.5757604 155.169698,64.7254394"
            />
            <path
              stroke="#FF9D00"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="14.751"
              d="M127.550697,57.3886421 C129.566396,53.8909104 196.177194,82.718187 223.334861,102.309855 C231.993172,107.077228 232.786185,110.984109 232.555517,116.149328 C232.32485,121.314548 227.100163,125.565023 217.5026,126.030684 C190.545448,127.340261 139.219742,108.783898 139.219742,108.783898 L134.794098,114.518008"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default HFLogo;
